import React, { useEffect, useState } from 'react'
import MyListBlock from '../../../../UI/list/MyListBlock'
import AgreeLawyerButton from '../../forms/agreeLawyer/AgreeLawyerButton'
import AgreeSecurityButton from '../../forms/agreeSecurity/AgreeSecurityButton'

const SupplierApproval = ({ supplier }) => {

    const [list, setList] = useState([])

    useEffect(() => {
        setListItems()
    }, [supplier])

    const setListItems = () => {
        const listTemp = []

        listTemp.push({
            name: 'Погоджено юристами?',
            value:
                <div className='approvalBlock'>
                    <AgreeLawyerButton 
                        supplier={supplier}
                    />
                </div>
            // value: '-'
        })
        listTemp.push({
            name: 'Погоджено службою безпеки?',
            // value: supplier ? supplier.id : '-'
            value: 
                <div className='approvalBlock'>
                    <AgreeSecurityButton 
                        supplier={supplier}
                    />
                </div>
        })

        setList(listTemp)
    }

  return (
    <MyListBlock
        className={'supplyOrderView__topBlock supplierApproval'}
        text={'Погодження'}
        list={list}
    />
  )
}

export default SupplierApproval